import { useEffect, useRef } from "react";
import Lenis from "lenis";

export const useLenis = () => {
    const frameRef = useRef(0);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        const raf = (time) => {
            lenis.raf(time);
            frameRef.current = requestAnimationFrame(raf);
        };
        frameRef.current = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frameRef.current);
            lenis.destroy();
        };
    }, []);
};
